import { createRouter, createWebHistory } from 'vue-router'
import loginSocial from '@/views/login-social/login-social.vue'
import home from '@/views/home/home-page.vue'
import signUp from '@/views/sign-up/sign-up.vue'
import codeValidation from '@/views/code-validation/CodeValidation.vue'
import logout from '@/views/logout/logout-session.vue'
import confirmAccount from '@/views/confirm_account/confirm_account.vue'
import history from '@/views/history/history.vue'
import campaign from '@/views/campaign/campaign-component.vue'
import PaymentMethods from '@/views/payment-methods/PaymentMethods.vue'
import TokenRedirect from '@/components/TokenRedirect.vue'
import URLRedirect from '@/components/URLRedirect.vue'
import FullScreenMap from '@/views/maps/FullScreenMap.vue'

function isAuthenticated() {
  return !!localStorage.getItem('token')
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'app',
      redirect: () => {
        return '/home'
      },
      meta: {
        public: true
      }
    },
    {
      path: '/home',
      name: 'home_page',
      component: home,
      meta: {
        public: false
      }
    },
    {
      path: '/sign-up',
      name: 'sign_up',
      component: signUp,
      meta: {
        public: true
      }
    },
    {
      path: '/login-social',
      name: 'login_social',
      component: loginSocial,
      meta: {
        public: true
      }
    },
    {
      path: '/code-validation',
      name: 'code_validation',
      component: codeValidation,
      meta: {
        public: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout,
      meta: {
        public: true
      }
    },
    {
      path: '/confirm-account/:code',
      name: 'confirm_account',
      component: confirmAccount,
      meta: {
        public: true
      }
    },
    {
      path: '/vw/:token?',
      name: 'campaign',
      component: campaign,
      meta: {
        public: true
      }
    },
    {
      path: '/maps',
      name: 'view-maps',
      component: FullScreenMap,
      meta: {
        public: true,
        hideBanner: true
      }
    },
    {
      path: '/history',
      name: 'history',
      component: history,
      meta: {
        public: false
      }
    },
    {
      path: '/payment-methods',
      name: 'payment_methods',
      component: PaymentMethods,
      meta: {
        public: false
      }
    },
    {
      path: '/qr/:token',
      name: 'qr',
      component: TokenRedirect,
      meta: {
        public: true
      }
    },
    {
      path: '/pineapples',
      name: 'url-redirect',
      component: URLRedirect,
      meta: {
        public: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuth = isAuthenticated()

  // Handle non-existent routes
  if (to.matched.length === 0) {
    next({ name: isAuth ? 'home_page' : 'login_social' })
    return
  }

  // Handle root app route
  if (to.name === 'app') {
    next({ name: isAuth ? 'home_page' : 'login_social' })
    return
  }

  // Protected routes: redirect to login if not auth
  if (!to.meta.public && !isAuth) {
    next({ name: 'login_social' })
    return
  }

  // Login page: redirect to home if already auth
  if (to.name === 'login_social' && isAuth) {
    next({ name: 'home_page' })
    return
  }

  next()
})

export default router
